export default __webpack_public_path__ + "8dca7b32deb8e5e39b15c3b1d8fd8bb4.webp";